import { render, staticRenderFns } from "./EventsReport.vue?vue&type=template&id=e606ee20&lang=html&"
import script from "./EventsReport.vue?vue&type=script&lang=js&"
export * from "./EventsReport.vue?vue&type=script&lang=js&"
import style0 from "./EventsReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
